//今は物件編集ページからオーナーの新規登録をさせていないのでこのコードは一時的に使われていない
import React from "react";
import {
  Grid,
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  RadioGroup,
  FormControlLabel,
  Radio,
  Button,
  Box,
  AlertColor,
} from "@mui/material";
import { Owner } from "./BuildingEditPage";
import { getJwtTokenFromIdToken } from "../auth/AuthFanc";
import ConfirmDialog from "../../molecules/ConfirmDialog";

interface OwnerRegistrationModalProps {
  newOwner: Owner;
  setNewOwner: React.Dispatch<React.SetStateAction<Owner>>;
  openOwnerRegistrationModal: boolean;
  setOpenOwnerRegistrationModal: React.Dispatch<React.SetStateAction<boolean>>;
  setSnackbarOpen: React.Dispatch<React.SetStateAction<boolean>>;
  setAlertSeverity: React.Dispatch<React.SetStateAction<AlertColor>>;
  setSnackbarMessage: React.Dispatch<React.SetStateAction<string>>;
}

const OwnerRegistrationModal: React.FC<OwnerRegistrationModalProps> = ({
  newOwner,
  setNewOwner,
  openOwnerRegistrationModal,
  setOpenOwnerRegistrationModal,
  setSnackbarOpen,
  setAlertSeverity,
  setSnackbarMessage,
}) => {
  // 確認ダイアログ
  const [openConfirm, setOpenConfirm] = React.useState(false);

  const handleOwnerFormSubmit = async (event: React.FormEvent) => {
    event.preventDefault(); // Submitイベントを停止します

    // JWTトークンを取得します
    const jwtToken = await getJwtTokenFromIdToken();

    try {
      // call storeOwner API
      const response = await fetch(
        process.env.REACT_APP_API_ENDPOINT + "/owners",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: jwtToken, // Authorizationヘッダーを追加
          },
          body: JSON.stringify({
            ownerName: newOwner.ownerName,
            departmentName: newOwner.departmentName,
            representativeName: newOwner.representativeName,
            picName: newOwner.picName,
            ownerPhone: newOwner.ownerPhone,
            ownerEmail: newOwner.ownerEmail,
            memo: newOwner.memo,
            isEnabled: newOwner.isEnabled,
          }),
        },
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      // 確認ダイアログを表示
      setOpenConfirm(true);
    } catch (error) {
      console.error("Error:", error);
    }

    setOpenOwnerRegistrationModal(false);
    setNewOwner({
      autoOwnerId: undefined,
      ownerId: "",
      password: "",
      subscribeNumber:"",
      ownerPhone: "",
      ownerEmail: "",
      ownerName: "",
      departmentName: "",
      representativeName: "",
      picName: "",
      isEnabled: true,
      memo: undefined,
      createdAt: "",
    });
  };

  return (
    <Dialog
      open={openOwnerRegistrationModal}
      onClose={() => setOpenOwnerRegistrationModal(false)}
    >
      <DialogTitle>LAD契約者（オーナー）新規登録</DialogTitle>
      <DialogContent>
        <form onSubmit={handleOwnerFormSubmit}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <TextField
                label="ID（登録時自動生成）"
                value={newOwner.ownerId}
                size="small"
                fullWidth
                onChange={(e) =>
                  setNewOwner({ ...newOwner, ownerId: e.target.value })
                }
                disabled
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                label="パスワード（登録時自動生成）"
                size="small"
                fullWidth
                disabled
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                label="名称(氏名)"
                value={newOwner.ownerName}
                size="small"
                fullWidth
                onChange={(e) =>
                  setNewOwner({ ...newOwner, ownerName: e.target.value })
                }
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                label="会社名(部署名)"
                value={newOwner.departmentName}
                size="small"
                fullWidth
                onChange={(e) =>
                  setNewOwner({ ...newOwner, departmentName: e.target.value })
                }
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                label="代表者名"
                value={newOwner.representativeName}
                size="small"
                fullWidth
                onChange={(e) =>
                  setNewOwner({
                    ...newOwner,
                    representativeName: e.target.value,
                  })
                }
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                label="担当者名"
                value={newOwner.picName}
                size="small"
                fullWidth
                onChange={(e) =>
                  setNewOwner({ ...newOwner, picName: e.target.value })
                }
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                label="電話番号"
                value={newOwner.ownerPhone}
                fullWidth
                onChange={(e) =>
                  setNewOwner({ ...newOwner, ownerPhone: e.target.value })
                }
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                label="メールアドレス"
                value={newOwner.ownerEmail}
                size="small"
                fullWidth
                onChange={(e) =>
                  setNewOwner({ ...newOwner, ownerEmail: e.target.value })
                }
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                label="メモ"
                value={newOwner.memo || ""}
                size="small"
                multiline
                minRows={3}
                fullWidth
                onChange={(e) =>
                  setNewOwner({ ...newOwner, memo: e.target.value })
                }
              />
            </Grid>
            <Grid item xs={12}>
              <RadioGroup
                row
                value={newOwner.isEnabled ? "有効" : "無効"}
                onChange={(e) =>
                  setNewOwner({
                    ...newOwner,
                    isEnabled: e.target.value === "有効",
                  })
                }
              >
                <FormControlLabel
                  value="有効"
                  control={<Radio />}
                  label="有効"
                />
                <FormControlLabel
                  value="無効"
                  control={<Radio />}
                  label="無効"
                />
              </RadioGroup>
            </Grid>
          </Grid>
          <Box display="flex" justifyContent="flex-end" marginTop={2}>
            <Button
              onClick={() => setOpenOwnerRegistrationModal(false)}
              variant="outlined"
              color="primary"
              style={{ marginRight: "10px" }}
            >
              閉じる
            </Button>
            <Button type="submit" variant="outlined" color="primary">
              登録
            </Button>
          </Box>
        </form>
      </DialogContent>
      <ConfirmDialog
        open={openConfirm}
        onClose={() => {
          setOpenConfirm(false);
        }}
        onConfirm={() => { }}
        title="確認"
        description={
          <>
            LAD契約者（オーナー）の作成が完了しました。
            <br />
            作成したLAD契約者（オーナー）を物件に登録するには「選択」からLAD契約者（オーナー）を選択し、「保存」を押下してください。
            <br />
            保存後、パスワードが表示されます。
          </>
        }
        showCancelButton={false}
      />
    </Dialog>
  );
};

export default OwnerRegistrationModal;
